import {create} from '../../../lib/instances'

const parentContainerClass = '.re-profile .re-profile-content'
const desktopContainer = 're-profile-menu-foot-content'
const mobileContainer = 'profile-loyalty-status'

const SHOW_SUMMARY = {
  component: 're-loyalty-status',
  componentOptions: {
    classes: false,
    component: {
      attributes: {}
    }
  },
  target: {
    targetSelector: `${parentContainerClass}`,
    root: `.${mobileContainer}`,
    element: `<div class="${mobileContainer}"></div>`,
    method: 'appendTo',
  },
  responsiveOptions: {
    removeParent: true
  },
  responsiveTargets: [
    {
      minWidth: 1120,
      targetSelector: `${parentContainerClass} .re-profile-menu`,
      root: `.${desktopContainer}`,
      element: `<li class="${desktopContainer}"></li>`,
      method: 'appendTo'
    }
  ]
}

const MOUNTED = 're-profile.mounted'

export default (Bus) => {
  Bus.$on(MOUNTED, async () => {
    create(SHOW_SUMMARY)
  })
}
